export const MENU_OPEN_CSS_CLASS = 'lateral-menu-is-open'
export const TRANSITION_MS_IN = 150
export const TRANSITION_MS_OUT = 100
